import { footerPartners } from '@/mocks/homepage';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl text-accent-400"></i>
              </div>
              <span className="text-xl font-bold text-background-50 font-heading whitespace-nowrap">
                玫瑰视频
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              玫瑰视频聚合91视频、91视频网站、久久视频、91在线视频等热门影视资源，提供高清免费在线观看服务，电视剧全集和电影大全不缓冲播放，致力于打造流畅、安全、便捷的观影平台。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-accent-600 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-background-300 text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-accent-600 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-background-300 text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center hover:bg-accent-600 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-background-300 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4 font-heading">
              <a href="#hero" className="hover:text-accent-400 transition-colors cursor-pointer">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">精选推荐</a></li>
              <li><a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">热门话题</a></li>
              <li><a href="#media" onClick={(e) => handleNavClick(e, '#media')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">热门视频</a></li>
              <li><a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">热播榜单</a></li>
              <li><a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">影视索引</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4 font-heading">
              <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="hover:text-accent-400 transition-colors cursor-pointer">帮助中心</a>
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">常见问题</a></li>
              <li><a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">联系我们</a></li>
              <li><a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">关于我们</a></li>
              <li><a href="#app" onClick={(e) => handleNavClick(e, '#app')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">移动观影</a></li>
              <li><a href="#features" onClick={(e) => handleNavClick(e, '#features')} className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">平台优势</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4 font-heading">合作伙伴</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerPartners.map((partner) => (
                <span
                  key={partner.name}
                  className="text-xs text-background-500 bg-background-800 px-3 py-2 rounded-md text-center whitespace-nowrap"
                >
                  {partner.name}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 玫瑰视频. 本站资源仅供个人学习交流使用，请勿用于商业用途。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">使用条款</a>
            <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#hero" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}